import React from 'react'
import { createFileRoute, useSearch } from '@tanstack/react-router'
import { AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/Button'

export const Route = createFileRoute('/error')({
  component: ErrorPage,
})

interface ErrorSearchParams {
  reason?: string
  subdomain?: string
  message?: string
}

function ErrorPage() {
  const search = useSearch({ from: '/error' }) as ErrorSearchParams
  const { reason, subdomain, message } = search

  const getErrorTitle = () => {
    if (reason === 'invalid-subdomain') {
      return 'Invalid Subdomain'
    }
    return 'Error'
  }

  const getErrorMessage = () => {
    if (reason === 'invalid-subdomain' && message) {
      return message
    }
    if (reason === 'invalid-subdomain' && subdomain) {
      return `The subdomain "${subdomain}" is not valid or is reserved.`
    }
    return 'An error occurred while accessing this page.'
  }

  const handleRedirect = () => {
    // Redirect to root domain (main website)
    window.location.href = 'https://sign.app' // TODO: Make this configurable via env var
  }

  return (
    <main className="mx-auto max-w-sm px-4 sm:px-6 md:px-8">
      <div className="flex min-h-screen flex-col items-center justify-center gap-6 text-center">
        <AlertCircle className="h-20 w-20 text-destructive" />
        <h1 className="text-3xl font-semibold text-foreground">
          {getErrorTitle()}
        </h1>
        <p className="text-base text-muted-foreground">
          {getErrorMessage()}
        </p>
        <p className="text-sm text-muted-foreground">
          Please use a valid tenant subdomain to access this application.
        </p>
        <Button
          variant="primary"
          size="lg"
          onClick={handleRedirect}
        >
          Return to Main Site
        </Button>
      </div>
    </main>
  )
}
